import React from "react";
import styled from "styled-components";

const Description = styled.p`
  font-size: 16px;
`;

const DescriptionTextTwo = ({ name, score, avgScoreOne, avgScoreTwo, t }) => {
  switch (name) {
    case "Klimat":
      return null;
    case "Social rättvisa":
      return null;
    case "Vatten":
      return (
        <Description>
          {t("Detta betyder alltså att produkten kräver")} <span>{score < avgScoreTwo ? t('mindre') : t('mer')}</span> {t("vatten för att produceras jämfört med genomsnittet av andra livsmedelsprodukter i databasen, och är")} <span>{score < avgScoreOne ? t('bra') : t('mindre bra')} </span> {t("om man jämför med produkter från samma livsmedelskategori.")}
        </Description>
      );
    case "Antibiotikaresistens":
      return <Description></Description>;
    case "Transport":
      return <Description></Description>;
    case "Landanvändning":
      return <Description></Description>;
    case "Bekämpningsmedel":
      return <Description></Description>;
    case "Övergödning":
      return <Description></Description>;
    case "Barnarbete":
      return <Description></Description>;
    case "Djurvälfärd":
      return <Description></Description>;
    case "Arbetsförhållanden":
      return <Description></Description>;
    case "Jämlikhet":
      return <Description></Description>;
    case "Lokalbefolkning":
      return <Description></Description>;
    default:
      return "";
  }
};

export default DescriptionTextTwo;
